import api from '@/apis'
import { mockDelay } from '@/apis/mockDelay'
import { IS_MOCK } from '@/constants'
import type { RegionDetail } from '@/types/serviceArea'

import { findMockRegionDetail } from './mocks'

export interface GetRegionDetailParams {
  /** 조회할 광역권역 (예: '서울', '경기'). URL 인코딩은 axios가 처리 */
  region: string

  /** 조회할 region 기준 하위 광역권역 (예: '경기 북부'). null/undefined면 전체 조회 */
  subRegion?: string | null
}

/**
 * 광역권역 상세 조회.
 *
 * 응답: 광역권역 → 시/도 → 시/군/자치구 → (일반구) → 동 nested 구조.
 * subRegion이 주어지면 해당 하위 광역권역에 속한 시군구만 응답에 포함.
 *
 * 사용처:
 *  - RegionMap에서 시각 자산(SVG)과 별개로 isFullCoverage 분기
 *  - SiGunGuGroup/DongAccordion에서 nested 트리 렌더링
 */
export const apiGetRegionDetail = async ({ region, subRegion }: GetRegionDetailParams): Promise<RegionDetail> => {
  if (IS_MOCK) {
    await mockDelay()
    return findMockRegionDetail(region, subRegion)
  }
  return await api.get<RegionDetail>(`/service-area/region/${encodeURIComponent(region)}`, {
    params: subRegion ? { subRegion } : undefined,
  })
}
